import { fetchDashboardStats } from "./dashboard-stats.service";
import { fetchProjects } from "./projects.service";
import { fetchEpisodes } from "./episodes.service";

export const dashboardService = {
  fetchDashboardStats,
  fetchProjects,
  fetchEpisodes,
};
